import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { QrGenerator } from "../components/QrGenerator";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.qr_tool_name()}
        toolPath="/qr-code-generator"
      />
      <SciHeader title={m.qr_h1()} intro={m.qr_intro()} />
      <QrGenerator />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.qr_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.qr_ex1(), m.qr_ex2(), m.qr_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.qr_faq_q1(), a: m.qr_faq_a1() },
          { q: m.qr_faq_q2(), a: m.qr_faq_a2() },
          { q: m.qr_faq_q3(), a: m.qr_faq_a3() },
          { q: m.qr_faq_q4(), a: m.qr_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
